import React from 'react';
import { Hero } from '../components/Hero';
import { ServicePillars } from '../components/ServicePillars';
import { ValueProposition } from '../components/ValueProposition';
import { Services } from '../components/Services';
import { TechStack } from '../components/TechStack';
import { Contact } from '../components/Contact';
import { Navigation } from '../components/Navigation';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { NexyomLogo } from '../components/NexyomLogo';
export function LandingPage() {
  return <div className="w-full" data-id="element-154">
      <Navigation data-id="element-155" />
      <Hero data-id="element-156" />

      {/* Featured Service Banner */}
      <Link to="/microsoft365" className="block" data-id="element-157">
        <section className="bg-blue-600 text-white py-4 relative overflow-hidden group cursor-pointer" data-id="element-158">
          <div className="absolute inset-0 bg-black/10 transition-opacity group-hover:bg-black/0" data-id="element-159" />
          <div className="max-w-7xl mx-auto px-6 flex items-center justify-center gap-4 relative z-10" data-id="element-160">
            <span className="font-bold tracking-wide uppercase text-sm md:text-base" data-id="element-161">
              Nouveau Service
            </span>
            <div className="h-4 w-px bg-white/30" data-id="element-162" />
            <span className="font-medium md:text-lg" data-id="element-163">
              Migration & Sécurisation Microsoft 365
            </span>
            <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-164" />
          </div>
        </section>
      </Link>

      <ServicePillars data-id="element-165" />
      <ValueProposition data-id="element-166" />
      <Services data-id="element-167" />
      <TechStack data-id="element-168" />
      <Contact data-id="element-169" />

      <footer className="bg-black text-white py-16 border-t border-white/10" data-id="element-170">
        <div className="max-w-6xl mx-auto px-6" data-id="element-171">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-172">
            <NexyomLogo variant="full" colorScheme="dark" size="sm" data-id="element-173" />
            <p className="text-gray-500 font-light tracking-wide" data-id="element-174">
              © 2025 Nexyom. Performance. Croissance. Ingénierie.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}